import React, { useState } from 'react';
import { Container, Wrapper, Title, Desc, CardContainer, ToggleButtonGroup, ToggleButton, Divider } from './ProjectsStyle';
import ProjectCard from '../Cards/ProjectCards';
import { projects } from '../../data/constants';

const Projects = ({ openModal, setOpenModal }) => {
  const [toggle, setToggle] = useState('all');

  return (
    <Container id="projects">
      <Wrapper>
        <Title>Projects</Title>
        <Desc>
          A selection of my work spanning full-stack web platforms, industry-sponsored engineering, and applied AI/ML systems.
        </Desc>
        <ToggleButtonGroup>
          <ToggleButton active={toggle === 'all'} value="all" onClick={() => setToggle('all')}>
            ALL
          </ToggleButton>
          <Divider />
          <ToggleButton active={toggle === 'web app'} value="web app" onClick={() => setToggle('web app')}>
            WEB APPS
          </ToggleButton>
          <Divider />
          <ToggleButton active={toggle === 'android app'} value="android app" onClick={() => setToggle('android app')}>
            ANDROID APPS
          </ToggleButton>
          <Divider />
          <ToggleButton active={toggle === 'machine learning'} value="machine learning" onClick={() => setToggle('machine learning')}>
            AI / MACHINE LEARNING
          </ToggleButton>
        </ToggleButtonGroup>
        <CardContainer>
          {projects
            .filter((item) => (toggle === 'all' ? true : item.category === toggle))
            .map((project) => (
              <ProjectCard
                key={project.id}
                project={project}
                openModal={openModal}
                setOpenModal={setOpenModal}
              />
            ))}
        </CardContainer>
      </Wrapper>
    </Container>
  );
};

export default Projects;
